import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box, Link } from "@mui/material";
import { Trans } from "react-i18next";
import { TELEGRAM_SUPPORT_URL } from "@/config";

export default function Faq() {
  const { translate, currentLang } = useLocales();
  return (
    <ContentWrap
      showBorderBottom={false}
      leftChildrenSx={{
        // paddingTop: "1px",
        paddingBottom: "32px",
      }}
      leftChildren={
        <CommonWrap>
          <Box id="support" component={"div"} className="title">
            {translate("support_help.support")}
          </Box>
          {currentLang.value === "en" && (
            <Box mt={3} id="faq" component={"div"} className="title_0">
              {translate("support_help.title")}
            </Box>
          )}
          <Box mb={3} />
          <>
            {currentLang.value !== "en" && (
              <Box component={"div"} className="title_0" id="faq">
                {translate("support_help.faq_title")}
              </Box>
            )}

            <Box mb={2} />

            <Box
              id="which-deposit-interface-should-i-use-for-my-business"
              component={"div"}
              className="title_0"
            >
              {translate("support_help.faq_list1_title")}
            </Box>

            <>
              <Box component={"div"} className="title_1">
                {translate("support_help.faq_list1_list1_title")}
              </Box>
              <Box
                sx={{
                  ul: {
                    paddingLeft: "2em",
                  },
                  li: {
                    "::marker": {
                      textIndent: "2em",
                    },
                  },
                }}
              >
                <ul>
                  <li>
                    <Box component={"div"} className="desc">
                      {translate("support_help.faq_list1_list1_desc1")}
                    </Box>
                  </li>
                  <li>
                    <Box component={"div"} className="desc">
                      {translate("support_help.faq_list1_list1_desc2")}
                    </Box>
                  </li>
                  <li>
                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"support_help.faq_list1_list1_desc3"}
                        t={translate as any}
                      >
                        s
                        <a
                          href={"#create-deposit-address-for-order"}
                          className="link"
                        >
                          Just a placeholder
                        </a>
                      </Trans>
                    </Box>
                  </li>
                </ul>
              </Box>
            </>

            <>
              <Box component={"div"} className="title_1">
                {translate("support_help.faq_list1_list2_title")}
              </Box>
              <Box
                sx={{
                  ul: {
                    paddingLeft: "2em",
                  },
                  li: {
                    "::marker": {
                      textIndent: "2em",
                    },
                  },
                }}
              >
                <ul>
                  <li>
                    <Box component={"div"} className="desc">
                      {translate("support_help.faq_list1_list2_desc1")}
                    </Box>
                  </li>
                  <li>
                    <Box component={"div"} className="desc">
                      {translate("support_help.faq_list1_list2_desc2")}
                    </Box>
                  </li>
                  <li>
                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"support_help.faq_list1_list2_desc3"}
                        t={translate as any}
                      >
                        s
                        <a
                          href={"#get-permanent-deposit-address"}
                          className="link"
                        >
                          Just a placeholder
                        </a>
                      </Trans>
                    </Box>
                  </li>
                </ul>
                {currentLang.value !== "en" && (
                  <Box component={"div"} className="desc">
                    <Trans
                      i18nKey={"support_help.faq_list1_list2_desc4"}
                      t={translate as any}
                    >
                      s
                      <Link
                        href={TELEGRAM_SUPPORT_URL}
                        target="_blank"
                        className="link"
                        underline="always"
                      >
                        Just a placeholder
                      </Link>
                    </Trans>
                  </Box>
                )}
              </Box>
            </>
            <Box mb={2} />
            {currentLang.value !== "en" && (
              <Box component={"div"} className="title_0">
                {translate("support_help.faq_list2_title")}
              </Box>
            )}

            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"support_help.faq_list2_title_desc"}
                t={translate as any}
              >
                s
                <Link
                  href={TELEGRAM_SUPPORT_URL}
                  target="_blank"
                  className="link"
                  underline="always"
                >
                  Just a placeholder
                </Link>
              </Trans>
            </Box>
          </>
        </CommonWrap>
      }
    />
  );
}
